import httpManager from "@/app/shared/utils/httpManager";

/**
 * Retrieves the embed link for a Gupshup WhatsApp application.
 */
export async function getEmbedLink(appId: string) {
  const url = `/channels/gupshup-waba/${appId}/embed-link/`;
  const response = await httpManager.get(url);
  return response?.data;
}
